
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Paper,Button, Typography, Grid } from "@mui/material"
import LineChartComponent from "../../components/Charts/LineChartComponent"
import DonutChartComponent from "../../components/Charts/DonutChartComponent"
import { readCampaignReportAPI } from '../../Redux/CampaignDucks';
import DataTable from 'react-data-table-component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { downloadCampaignReportAPI } from '../../Redux/CampaignDucks';

export default function ReportCampaignDetailPage() {
    const { campaignId } = useParams();
    
    const [contacts, setContacts] = useState([]);
    const [responsesData, setResponsesData] = useState([]);
    const [performanceData, setPerformanceData] = useState([]);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);
    
    const dispatch = useDispatch()
    const currentCampaign = useSelector(store => store.campaign.currentCampaign);
    
    
    useEffect(() => {
        if (campaignId) {
          dispatch(readCampaignReportAPI(campaignId));
        }
    }, [campaignId]);

    useEffect(() => {
        if (currentCampaign && currentCampaign.messageDetails) {
            setContacts(currentCampaign.messageDetails);
        }
        // Prepare data for charts
        if (currentCampaign && currentCampaign.responseTypes) {
            setResponsesData(currentCampaign.responseTypes);
        }
        if (currentCampaign && currentCampaign.performanceData) {
            setPerformanceData(currentCampaign.performanceData);
        }
        if (currentCampaign && currentCampaign.campaignName ) {
          setTitle(currentCampaign.campaignName);
        }

    }, [currentCampaign]);

    const handleBackward = () => {
      window.history.back();
    }

    const handleDownload = () => {
      dispatch(downloadCampaignReportAPI(campaignId));
      // setFlowData(Data); // Data se actualizará por Redux
    };

    // const filteredItems = campaigns.filter(
    //         item => (item.templateName && item.templateName.toLowerCase().includes(filterText.toLowerCase())) ||
    //             (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
    //     );
    
    const columns = [
            {
                name: 'ID',
                selector: row => row.id,
                sortable: true,
                maxWidth: "100px"
            },
            {
                name: 'Nombre',
                selector: row => row.name,
                sortable: true
                
            },
            {
               name: 'Número de WhatsApp',
                selector: row => row.phoneNumber,
                sortable: true
            },
            {
                name: 'Estado de envio',
                selector: row => row.status,
                sortable: true
            },
            {
                name: 'Respuesta de plantilla',
                selector: row => row.templateResponse,
                sortable: true
            },
            {
                name: 'Última respuesta',
                selector: row => row.response,
                sortable: true,
                grow: 2
            },
            {
                name: 'Fecha de Respuesta',
                selector: row => row.responseDate ? new Date(row.responseDate).toLocaleString('es-CL') : '-',
                sortable: true
            },
        ];

  return (
    <Container maxWidth={false} sx={{ px: 2 }}>
      <Box sx={{ mb: 0, display: 'flex', alignItems: 'center' }}>
        <Button variant="text" startIcon={<ArrowBackIcon />} onClick={handleBackward}>
          Volver
        </Button>
      </Box>

      <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Grid item>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleDownload} color="success">
            Descargar
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <LineChartComponent data={performanceData} />
        </Box>
        <Box sx={{ width: 450 }}>
          <DonutChartComponent data={responsesData} />
        </Box>
      </Box>

      <Box>
        <Paper className="apple-card">
          <DataTable
            columns={columns}
            data={contacts}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 30]}
            progressPending={loading}
            persistTableHead
            customStyles={customStyles}
          />
        </Paper>
      </Box>
    </Container>
  )
}

const customStyles = {
  table: {
    style: {
      minWidth: '80vw',
      maxWidth: '90vw'
    },
  },
  headRow: {
    style: {
      backgroundColor: '#F2F2F7',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#86868B',
      textTransform: 'uppercase',
    },
  },
  cells: {
    style: {
      fontSize: '14px',
      color: '#1D1D1F',
    },
  },
};
